const WORKOS_REDIRECT = '/auth/workos/redirect';
export const API_BASE_PATHS = {
  ACCOUNTS: '/accounts',
  ALLOCATION_TEMPLATES: '/allocation-templates',
  AUTH: {
    CHANGE_PASSWORD: '/auth/changePassword',
    FORGOT_PASSWORD: '/auth/forgotPassword',
    GENERATE_WELCOME_OR_RESET_PASSWORD_URL:
      '/auth/generateWelcomeOrResetPasswordUrl',
    GOOGLE: '/auth/google',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    MICROSOFT: '/auth/microsoft',
    REFRESH_USER_TOKEN: '/auth/refreshUserToken',
    RESET_PASSWORD: '/auth/resetPassword',
    RESTORE_SESSION: '/auth/restoreSession',
    SIGNUP: '/auth/signup',
    SSO_LOGIN: '/auth/ssoLogin',
    SWITCH_ORGANIZATION: '/auth/switchOrganization',
    TOKEN_LOGIN: '/auth/tokenLogin',
    VERIFY_CURRENT_USER_ACCOUNT_PROVIDER:
      '/auth/verifyCurrentUserAccountProvider',
    WORKOS_CALLBACK: '/auth/workos/callback',
    WORKOS_CHANGE_PASSWORD: '/auth/workos/changePassword',
    WORKOS_FORGOT_PASSWORD: '/auth/workos/forgotPassword',
    WORKOS_INITIATE: '/auth/workos/initiate',
    WORKOS_LOGIN: '/auth/workos/login',
    WORKOS_LOGOUT: '/auth/workos/logout',
    WORKOS_REDIRECT_GOOGLE: `${WORKOS_REDIRECT}/google`,
    WORKOS_REDIRECT_MICROSOFT: `${WORKOS_REDIRECT}/microsoft`,
    WORKOS_RESET_PASSWORD: '/auth/workos/resetPassword',
    WORKOS_SIGNUP: '/auth/workos/signup',
    WORKOS_VERIFY_EMAIL: '/auth/workos/verifyEmail',
  },
  BILLS: '/bills',
  BUDGETS: '/budgets',
  CONTACT_US: '/contact-us',
  CREDENTIALS: '/credentials',
  BIGQUERY: '/bigquery',
  ENERGY_ASSETS: '/energyAssets',
  FACILITIES: '/facilities',
  FACILITY_GROUPS: '/facilityGroups',
  HIDDEN_DATA_INSIGHTS: '/hiddenDataInsights',
  IMPORT_FILES: '/import-files',
  LINE_ITEM_SUBTYPES: '/lineItemSubtypes',
  LUZMO_DASHBOARDS: '/luzmo-dashboards',
  METADATA: {
    ALERTS: '/metadata/alerts',
    DATA_INSIGHTS: '/metadata/dataInsights',
    OPERATIONS: '/metadata/operations',
    TAGS: '/metadata/import-file-tags',
  },
  METERS: '/meters',
  ORGANIZATIONS: '/organizations',
  ORGANIZATION_GROUPS: '/organizationGroups',
  PROJECTS: '/projects',
  STATEMENTS: '/statements',
  USERS: '/users',
  UTILITIES: '/utilities',
  WORK_ORDERS: '/workOrders',
};

export const formContentType = 'multipart/form-data';
export const jsonContentType = 'application/json';

/**
 * The query keys used throughout the application to identify cached data.
 * @constant
 * */
export const QUERY_KEYS = {
  alerts: 'alerts',
  alertNotes: 'alertNotes',
  alertsBadgeCount: 'alertsBadgeCount',
  accounts: 'accounts',
  credentials: 'credentials',
  detailPageData: 'detailPageData',
  importFiles: 'importFiles',
  meters: 'meters',
  organizations: 'organizations',
  statements: 'statements',
  tags: 'tags',
  uploadedBills: 'uploadedBills',
  utilities: 'utilities',
  users: 'users',
};
